<template>
  <div class="myaccount">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <CommonHead></CommonHead>
    <div class="accountdetails">
      <sidebar></sidebar>
      <div class="orderspage">
        <div class="singleorder">
          <b-link @click="$router.go(-1)" class="backtoorder">
            <b-img class="backarrow" src="/shop/images/arrow.svg" alt="Arrow image"></b-img>Back to Orders
          </b-link>
          <div class="orderinfo">
            <div class="detailedinfo">
              <h3>Order Information</h3>
              <b-link href="javascript:;" @click="getPDF()" class="downpdf mobiledownload">
                <b-img class="backarrow" src="/shop/images/download.svg" alt="Download image"></b-img>Download Pdf
              </b-link>
              <div class="samediv">
                <span>Order #</span>
                <p>{{orderdetails.salesid}}</p>
              </div>
              <div class="samediv">
                <span>Date</span>
                <p>{{orderdetails.DateCreated}}</p>
              </div>
              <div class="samediv">
                <span>Order Type</span>
                <p>{{orderdetails.ORDERTYPE}}</p>
              </div>
              <div class="samediv">
                <span>Order Status</span>
                <p>{{orderdetails.SALESSTATUSTEXT}}</p>
              </div>
                <div class="samediv" v-if="orderdetails.TrackingNumber">
                    <span>Tracking Number</span>
                    <p>{{orderdetails.TrackingNumber}}</p>
                </div>
              <div class="samediv" v-if="orderdetails.NOTES">
                <span>Special Instructions</span>
                <p>{{orderdetails.NOTES}}</p>
              </div>
              <div class="orderimg" v-for="item in orderdetails.items" :key="item">
                <div class="imgcont">
                  <b-img :src="item.SMALL_IMAGE" alt="order image"></b-img>
                </div>
                <div class="detailcont">
                  <h3>{{item.ItemName}}</h3>
                  <div class="samediv">
                    <span>ID :</span>
                    <p>{{item.rmcchilditem}}-{{item.INVENTCOLORID}}</p>
                  </div>
                  <div class="samediv">
                    <span>Price :</span>
                    <p>$ {{item.SALESPRICE}}</p>
                  </div>
                  <div class="samediv">
                    <span>Qty :</span>
                    <p>{{item.salesqty}}</p>
                  </div>
                  <div class="samediv">
                    <span>Subtotal:</span>
                    <p>$ {{item.SUBTOTAL}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="downloadpdf">
              <b-link href="javascript:;" @click="getPDF()" class="downpdf">
                <b-img class="backarrow" src="/shop/images/download.svg" alt="Download image"></b-img>Download Pdf
              </b-link>
              <div class="boxgrid">
                <span>Bill To</span>
                <p>{{orderdetails.NAME}}</p>
                <p>{{orderdetails.STREET}},{{orderdetails.CITY}}, {{orderdetails.STATE}} {{orderdetails.ZIPCODE}} {{orderdetails.COUNTRYREGIONID}}</p>
                <span class="shipto">Ship To</span>
                <p>{{orderdetails.DELIVERYNAME}}</p>
                <p>{{orderdetails.Del_street}},{{orderdetails.Del_City}}, {{orderdetails.Del_State}} {{orderdetails.Del_zip}} {{orderdetails.Del_Country}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sidebar from "@/components/Sidebar";
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";
import ResourceMixin from "../../mixins/resources";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Sidebar,
    CommonHead,
    CommonFoot,
    Loading
  },
  mixins: [ResourceMixin],
  mounted() {
      this.isLoading = true;
      this.$store.dispatch("loadOrderInfo",this.$route.params.salesid).then(orderdetails => {
          this.orderdetails = orderdetails.data;
          this.isLoading = false;
      });
  },
  data() {
    return {
      orderdetails:[],
      isLoading: false,
      breadcrumb: [
        {
          text: "My Account",
          active: true
        }
      ]
    };
  },
  methods:{
    getPDF(){
      this.isLoading = true;
      this.$store.dispatch("loadOrderPDF",this.$route.params.salesid).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'order.pdf');
        document.body.appendChild(link);
        link.click();
        this.isLoading = false;
      });
    },
  }
};
</script>
<style>
.accountdetails .orderspage {
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: left;
  justify-content: left;
  flex-wrap: wrap;
  margin-top: 40px;
  padding-left: 40px;
  width: 100%;
  margin-left: 26.3% !important;
  min-height: 615px;
  max-width: 100%;
}
.accountdetails .orderspage .singleorder {
  width: 100%;
  border-radius: 0;
  border: none;
  max-width: 1110px;
  padding-right: 40px;
  box-sizing: border-box;
}
.accountdetails .orderspage .singleorder a.backtoorder {
  font-size: 14px;
  color: #303030;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 12px;
  display: inline-block;
  border-bottom: 1px solid #ffffff;
}
.accountdetails .orderspage .singleorder a.backtoorder:hover{
  border-bottom: 1px solid #303030;
}
.accountdetails .orderspage .singleorder a.backtoorder img {
  width: 12px;
  height: 12px;
  float: left;
  margin-right: 7px;
  margin-top: 3px;
  transform: rotate(90deg);
}
.accountdetails .orderspage .singleorder .orderinfo {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 100px;
}
.accountdetails .orderspage .singleorder .orderinfo h3 {
  text-align: left;
  margin-bottom: 10px !important;
  display: inline-block;
}
.accountdetails .orderspage .singleorder .orderinfo .samediv {
  margin-bottom: 8px;
  display: inline-block;
  width: 100%;
}
.accountdetails .orderspage .singleorder .orderinfo .samediv p {
  font-weight: normal;
  color: #303030;
  font-size: 14px;
  display: inline-block;
  margin-top: 2px;
}
.accountdetails .orderspage .singleorder .orderinfo .orderimg {
  display: flex;
  justify-content: space-between;
  padding: 30px 40px 30px 0;
  box-sizing: border-box;
  max-width: 560px;
  border-bottom: 1px solid #d2d2d2;
}
.accountdetails .orderspage .singleorder .orderinfo .orderimg:last-child {
  border-bottom: 0;
}
.accountdetails .orderspage .singleorder .orderinfo .orderimg .imgcont {
  width: 170px;
  height: 170px;
}
.accountdetails .orderspage .singleorder .orderinfo .orderimg .imgcont img {
  width: 100%;
  border-radius: 3px;
  margin-top: 5px;
}
.accountdetails .orderspage .singleorder .orderinfo .orderimg .detailcont {
  width: 62%;
}
.accountdetails .orderspage .singleorder .orderinfo .downloadpdf {
  width: 45.5%;
}
.downpdf.mobiledownload{
	display:none;
}
.accountdetails .orderspage .singleorder .orderinfo .downloadpdf .downpdf {
  color: #303030;
  font-size: 14px;
  text-decoration: none;
  font-weight: 600;
  float: right;
  border-bottom: 1px solid #ffffff;
}
.accountdetails
  .orderspage
  .singleorder
  .orderinfo
  .downloadpdf
  .downpdf:hover {
  border-bottom: 1px solid #303030;
}
.accountdetails
  .orderspage
  .singleorder
  .orderinfo
  .downloadpdf
  .downpdf
  img.backarrow {
  height: 13px;
  width: 13px;
  display: inline-block;
  margin-right: 10px;
  margin-top: -3px;
}
.accountdetails .orderspage .singleorder .orderinfo .downloadpdf .boxgrid {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 35px;
  position: relative;
  margin: 20px 0 0 0;
  flex-basis: inherit;
  display: inline-block;
}
.accountdetails .orderspage .singleorder .orderinfo .downloadpdf .boxgrid span {
  width: 100%;
  display: inline-block;
  margin: 0;
}
.accountdetails
  .orderspage
  .singleorder
  .orderinfo
  .downloadpdf
  .boxgrid
  span.shipto {
  margin-top: 20px;
  display: inline-block;
  width: 100%;
}
.accountdetails .orderspage .singleorder .orderinfo .downloadpdf .boxgrid p {
  margin: 0;
}
.accountdetails
  .orderspage
  .singleorder
  .orderinfo
  .detailcont
  .samediv:last-child {
  margin: 0;
}
@media only screen and (max-width: 1500px) and (min-width: 1420px) {
  .accountdetails .orderspage .singleorder .orderinfo .orderimg {
    width: 90%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg .detailcont {
    width: 60%;
  }
}
@media only screen and (max-width: 1419px) and (min-width: 1301px) {
  .accountdetails .orderspage .singleorder .orderinfo .orderimg {
    width: 90%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg .detailcont {
    width: 56%;
  }
}
@media only screen and (max-width: 1300px) {
  .accountdetails .orderspage {
    max-width: 930px !important;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1025px) {
  .accountdetails .orderspage .singleorder .orderinfo .downloadpdf .boxgrid{
    padding:20px;
  }
}
@media only screen and (max-width:1024px) and (min-width:768px){
	.downpdf{
		display:none;
	}
	.downpdf.mobiledownload{
		display:block;
		color: #303030;
		font-size: 14px;
		text-decoration: none;
		font-weight: 600;
		float: right;
		border-bottom: 1px solid #ffffff;
	}
	.downpdf.mobiledownload  img.backarrow{
		height: 13px;
		width: 13px;
		display: inline-block;
		margin-right: 10px;
		margin-top: -3px;
	}
	.accountdetails .orderspage .singleorder .orderinfo .orderimg{
		align-items:center;
		padding-right:0;
	}
  .accountdetails .orderspage .singleorder{
    max-width: 100%;
    padding: 0 20px;
  }
  .accountdetails .orderspage .singleorder .orderinfo{
    flex-wrap: wrap;
    margin-bottom: 50px;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg:last-child{
    padding-right: 0;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg .imgcont {
    width: 180px;
    height: 180px;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg .detailcont {
    width: 57%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .samediv p{
    font-size: 12px;
  }
  .accountdetails .orderspage .singleorder .orderinfo .downloadpdf {
    width: 100%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .downloadpdf .boxgrid{
    padding:20px;
  }
}
@media only screen and (max-width:767px){
	.downpdf{
		display:none;
	}
	.downpdf.mobiledownload{
		display:block;
		color: #303030;
		font-size: 14px;
		text-decoration: none;
		font-weight: 600;
		float: right;
		border-bottom: 1px solid #ffffff;
	}
	.downpdf.mobiledownload  img.backarrow{
		height: 13px;
		width: 13px;
		display: inline-block;
		margin-right: 10px;
		margin-top: -3px;
	}
  .accountdetails .orderspage {
    max-width: 100% !important;
    margin-left: 0 !important;
    padding: 0 20px;
  }
  .accountdetails .orderspage .singleorder{
    max-width: 100%;
    padding-right: 0;
  }
  .accountdetails .orderspage .singleorder .orderinfo{
    flex-wrap: wrap;
    margin-bottom: 50px;
  }
  .accountdetails .orderspage .singleorder .orderinfo .detailedinfo{
	width:100%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg{
	padding-right:10px;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg:last-child{
    padding-right: 0;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg .imgcont {
    width: 150px;
    height: 150px;
  }
  .accountdetails .orderspage .singleorder .orderinfo .orderimg .detailcont {
    width: 53%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .samediv p{
    font-size: 12px;
  }
  .accountdetails .orderspage .singleorder .orderinfo .downloadpdf {
    width: 100%;
  }
  .accountdetails .orderspage .singleorder .orderinfo .downloadpdf .boxgrid{
    padding:20px;
  }
}
@media only screen and (max-width:360px){
.accountdetails .orderspage .singleorder .orderinfo .orderimg .imgcont {
    width: 130px;
    height: 130px;
}
.accountdetails .orderspage .singleorder .orderinfo h3{
	word-break: break-word;
}
}
</style>
